<template>
    <b-overlay :show="loading" rounded="sm">
        <div class="enquiry-container" v-if="!mobile">
            <div class="enquiry-detail">
                <div class="enquiry-header">
                    <div class="enquiry-title">
                        <span class="enquiry-title-name">{{ title }}</span>
                        <div class="enquiry-title-unread" v-if="unread">{{ $t("lbl_EMPBE_SalesLead_Unread") }}</div>
                    </div>
                    <div class="enquiry-subtitle">
                        <span class="enquiry-subtitle-date">{{ inquiryDateLine }}</span>
                        <span class="enquiry-subtitle-unicode">{{ $t("lbl_EMPBE_SalesLead_Ref").replace("{enquiryCode}",
                            InquiryDetail.uniqueCode) }}</span>

                    </div>
                </div>
                <div class="enquiry-unLock" v-if="['Guest'].includes(BoothType)">
                    <unlockQuota_Free Type="2" unlockType="Enquiry" :user="user" :rid="rid" :mobile="mobile" @unlockQuota="unlockQuota($event)" :simulatedSupplier="simulatedSupplier" >
                    </unlockQuota_Free>
                </div>
                <div class="enquiry-body-container">
                    <div class="enquiry-body">
                        <div class="enquiry-body-left">
                            <span class="enquiry-body-left-header" v-if="isProduct">{{
                                $t("lbl_EMPBE_SalesLead_ProductEnquiry") }}</span>
                            <span class="enquiry-body-left-header" v-else>{{ $t("lbl_EMPBE_SalesLead_GeneralEnquiry")
                                }}</span>
                            <div class="enquiry-body-left-requirment-container">
                                <div class="enquiry-body-left-requirment-product" v-if="isProduct">
                                    <div class="enquiry-body-left-requirment-product-img-container" v-if="productPhoto">
                                        <img class="enquiry-body-left-requirment-product-img" :src="productPhoto"
                                            loading="lazy" alt="Product Img" width="96px" height="72px">
                                    </div>
                                    <div class="enquiry-body-left-requirment-product-name-container">
                                        <span class="enquiry-body-left-requirment-product-name">{{ productName }}</span>
                                    </div>
                                </div>
                                <div class="enquiry-body-left-requirment" v-if="isProduct && InquiryDetail.qty">
                                    <span class="enquiry-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_SourcingQuantity") }}</span>
                                    <div class="enquiry-body-left-requirment-detail-container">
                                        <span class="enquiry-body-left-requirment-detail"> {{ InquiryDetail.qty
                                        }}</span>
                                    </div>
                                </div>
                                <div class="enquiry-body-left-requirment" v-if="InquiryDetail.content">
                                    <span class="enquiry-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_Requirements") }}</span>
                                    <div class="enquiry-body-left-requirment-detail-container">
                                        <span class="enquiry-body-left-requirment-detail"> {{ InquiryDetail.content
                                        }}</span>
                                    </div>
                                </div>
                                <!-- <unlockToView v-if="InquiryDetail.isFreeBooth"/> -->
                            </div>
                        </div>
                        <div class="enquiry-body-right">
                            <span class="enquiry-body-right-title">{{ $t("lbl_EMPBE_SalesLead_ContactInfo") }}</span>
                            <div class="enquiry-body-right-body">
                                <div class="enquiry-body-right-body-info-container">
                                    <div class="enquiry-body-right-body-info">
                                        <span class="enquiry-body-right-body-info-title">{{
                                            $t("lbl_EMPBE_ReportAll_Table_CompanyName") }}</span>
                                        <span class="enquiry-body-right-body-info-detail">{{ InquiryDetail.compname
                                        }}</span>
                                    </div>
                                    <div class="enquiry-body-right-body-info">
                                        <span class="enquiry-body-right-body-info-title">{{
                                            $t("lbl_EMPBE_SalesLead_Name") }}</span>
                                        <span class="enquiry-body-right-body-info-detail">{{
                                            InquiryDetail.surname }}</span>
                                    </div>
                                    <div class="enquiry-body-right-body-info">
                                        <span class="enquiry-body-right-body-info-title">{{
                                            $t('lbl_EMPBE_CountryOrArea') }}</span>
                                        <span class="enquiry-body-right-body-info-detail">{{ countryName }}</span>
                                    </div>
                                    <div class="enquiry-body-right-body-info">
                                        <span class="enquiry-body-right-body-info-title">{{
                                            $t("lbl_EMPBE_SalesLead_Mobile") }}</span>
                                        <span class="enquiry-body-right-body-info-detail">{{ InquiryDetail.tel }}</span>
                                    </div>
                                    <div class="enquiry-body-right-body-info">
                                        <span class="enquiry-body-right-body-info-title">{{ $t('Lbl_EmailAddress')
                                            }}</span>
                                        <span class="enquiry-body-right-body-info-detail">{{ InquiryDetail.email
                                        }}</span>
                                    </div>

                                </div>
                                <unlockToView v-if="InquiryDetail.isFreeBooth && IsLock" />
                                <span class="enquiry-body-right-body-text" v-else>{{ $t('lbl_EMPBE_SalesLead_Footer') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="enquiry-remarks" v-if="rid">
                <MessageThread
                    :key="'remarks-' + rid"
                    :source-type="'Inquiry'"
                    :source-id="rid"
                    log-form-type-prefix="SalesleadBack_"
                    :simulated-supplier="!!simulatedSupplier"
                    :max-depth="5"
                    :allow-create="true"
                    :allow-reply="false"
                    :allow-delete="false"
                    :root-level-only="true"
                />
            </div>
        </div>
        <div class="enquiry-container" v-if="mobile">
            <div class="enquiry-detail">
                <div class="enquiry-header-container">
                    <i @click="$emit('close')" style="width: 24px; height: 24px;">
                        <img src="https://cdn.adsalecdn.com/EMP/2-0/NameCard/SalesLead_Back_Arrow.svg" alt="返回" width="24" height="25" />
                    </i>
                    <div class="enquiry-header">
                        <div class="enquiry-title">
                            <span class="enquiry-title-name">{{ title }}</span>
                            <div class="enquiry-title-unread" v-if="unread">{{ $t("lbl_EMPBE_SalesLead_Unread") }}</div>
                        </div>
                        <div class="enquiry-subtitle">
                            <span class="enquiry-subtitle-date">{{ inquiryDateLine }}</span>
                            <span class="enquiry-subtitle-unicode">{{
                                $t("lbl_EMPBE_SalesLead_Ref").replace("{enquiryCode}",
                                InquiryDetail.uniqueCode) }}</span>

                        </div>
                    </div>
                </div>
                <div class="enquiry-unLock" v-if="['Guest'].includes(BoothType)">
                    <unlockQuota_Free Type="2" unlockType="Enquiry" :user="user" :rid="rid" :mobile="mobile" @unlockQuota="unlockQuota($event)" :simulatedSupplier="simulatedSupplier">
                    </unlockQuota_Free>
                </div>
                <div class="enquiry-body-container">
                    <div class="enquiry-body">
                        <div class="enquiry-body-left">
                            <span class="enquiry-body-left-header" v-if="isProduct">{{
                                $t("lbl_EMPBE_SalesLead_ProductEnquiry") }}</span>
                            <span class="enquiry-body-left-header" v-else>{{ $t("lbl_EMPBE_SalesLead_GeneralEnquiry")
                                }}</span>
                            <div class="enquiry-body-left-requirment-container">
                                <div class="enquiry-body-left-requirment-product" v-if="isProduct">
                                    <div class="enquiry-body-left-requirment-product-img-container" v-if="productPhoto">
                                        <img class="enquiry-body-left-requirment-product-img" :src="productPhoto"
                                            loading="lazy" alt="Product Img" height="72px" width="96px">
                                    </div>
                                    <div class="enquiry-body-left-requirment-product-name-container">
                                        <span class="enquiry-body-left-requirment-product-name">{{ productName }}</span>
                                    </div>
                                </div>
                                <div class="enquiry-body-left-requirment" v-if="isProduct && InquiryDetail.qty">
                                    <span class="enquiry-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_SourcingQuantity") }}</span>
                                    <div class="enquiry-body-left-requirment-detail-container">
                                        <span class="enquiry-body-left-requirment-detail"> {{ InquiryDetail.qty
                                        }}</span>
                                    </div>
                                </div>
                                <div class="enquiry-body-left-requirment" v-if="InquiryDetail.content">
                                    <span class="enquiry-body-left-requirment-title">{{
                                        $t("lbl_EMPBE_SalesLead_Requirements") }}</span>
                                    <div class="enquiry-body-left-requirment-detail-container">
                                        <span class="enquiry-body-left-requirment-detail"> {{ InquiryDetail.content
                                        }}</span>
                                    </div>
                                </div>
                                <!-- <unlockToView v-if="InquiryDetail.isFreeBooth"/> -->
                            </div>
                        </div>
                        <div class="enquiry-body-right">
                            <span class="enquiry-body-right-title">{{ $t("lbl_EMPBE_SalesLead_ContactInfo") }}</span>
                            <div class="enquiry-body-right-body">
                                <div class="enquiry-body-right-body-info-container">
                                    <div class="enquiry-body-right-body-info">
                                        <span class="enquiry-body-right-body-info-title">{{
                                            $t("lbl_EMPBE_ReportAll_Table_CompanyName") }}</span>
                                        <span class="enquiry-body-right-body-info-detail">{{ InquiryDetail.compname
                                        }}</span>
                                    </div>
                                    <div class="enquiry-body-right-body-info">
                                        <span class="enquiry-body-right-body-info-title">{{
                                            $t("lbl_EMPBE_SalesLead_Name") }}</span>
                                        <span class="enquiry-body-right-body-info-detail">{{
                                            InquiryDetail.surname }}</span>
                                    </div>
                                    <div class="enquiry-body-right-body-info">
                                        <span class="enquiry-body-right-body-info-title">{{
                                            $t('lbl_EMPBE_CountryOrArea') }}</span>
                                        <span class="enquiry-body-right-body-info-detail">{{ countryName }}</span>
                                    </div>
                                    <div class="enquiry-body-right-body-info">
                                        <span class="enquiry-body-right-body-info-title">{{
                                            $t("lbl_EMPBE_SalesLead_Mobile") }}</span>
                                        <span class="enquiry-body-right-body-info-detail">{{ InquiryDetail.tel }}</span>
                                    </div>
                                    <div class="enquiry-body-right-body-info">
                                        <span class="enquiry-body-right-body-info-title">{{ $t('Lbl_EmailAddress')
                                            }}</span>
                                        <span class="enquiry-body-right-body-info-detail">{{ InquiryDetail.email
                                        }}</span>
                                    </div>

                                </div>
                                <unlockToView v-if="InquiryDetail.isFreeBooth && IsLock" />
                                <span class="enquiry-body-right-body-text" v-else>{{ $t('lbl_EMPBE_SalesLead_Footer') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="enquiry-remarks" v-if="rid">
                <MessageThread
                    :key="'remarks-m-' + rid"
                    :source-type="'Inquiry'"
                    :source-id="rid"
                    log-form-type-prefix="SalesleadBack_"
                    :simulated-supplier="!!simulatedSupplier"
                    :max-depth="5"
                    :allow-create="true"
                    :allow-reply="false"
                    :allow-delete="false"
                    :root-level-only="true"
                />
            </div>
        </div>

    </b-overlay>
</template>
<script>
import unlockToView from './unlockToView.vue';
import unlockQuota_Free from './unlockQuota_Free.vue';
import MessageThread from '@/components/MessageBoard/MessageThread.vue';
import { formatSalesLeadDate } from '@/_helpers/formatSalesLeadDate';
import { formatSalesLeadTitleWithCountry } from '@/_helpers/formatSalesLeadTitleWithCountry';
export default {
    props: {
        InquiryDetail: Object,
        loading: Boolean,
        mobile: Boolean,
        user: Object,
        rid: Number,
        simulatedSupplier:Object
    },
    inject: ["permissionData", "GetDetail"],
    data() {
        return {
            IsLock: false
        }
    },
    components: {
        unlockToView,
        unlockQuota_Free,
        MessageThread
    },
    computed: {
        BoothType(){
            // `permissionData` may be provided as:
            // - plain object { Type: 'Guest' | ... }
            // - a ref-like object { value: {...} }
            // - (rare) a getter function returning the object
            const raw = this.permissionData;
            // If inject/provide is missing, still allow UI to work based on user fields.
            if (!raw) {
                const u = this.user || {};
                if (u.eBoothGrade) return u.eBoothGrade;
                if (Number(u.isMember) > 0) return 'Member';
                if (Number(u.isExhibitor) > 0) return 'Guest';
                return undefined;
            }
            if (typeof raw === 'function') {
                try {
                    return raw()?.Type;
                } catch (e) {
                    return undefined;
                }
            }
            // plain object
            if (raw?.Type) return raw.Type;
            // ref-like
            const injectedType = raw?.value?.Type;
            if (injectedType) return injectedType;

            // Fallback: infer from `user` (works even when inject/provide isn't available)
            const u = this.user || {};
            if (u.eBoothGrade) return u.eBoothGrade;
            if (Number(u.isMember) > 0) return 'Member';
            if (Number(u.isExhibitor) > 0) return 'Guest';
            return undefined;
        },  
        inquiryDateLine() {
            if (!this.InquiryDetail?.cdate) return '';
            return this.$t('lbl_EMPBE_SalesLead_Date', {
                sendDateOfEnquiry: formatSalesLeadDate(this.InquiryDetail.cdate),
            });
        },
        unread() {
            return this.InquiryDetail.readDate == '9999-12-31'
        },
        isProduct() {
            return this.InquiryDetail.seqId != 0
        },
        langId() {
            return localStorage.getItem("currentLangId")
        },
        productName() {
            switch (this.langId) {
                case '936':
                    return this.InquiryDetail?.exhibitNameS

                case '950':
                    return this.InquiryDetail?.exhibitNameT

                case '1252':
                    return this.InquiryDetail?.exhibitName

                default:
                    return ""

            }
        },
        countryName() {
            switch (this.langId) {
                case '950':
                    return this.InquiryDetail?.countryName_trad
                case '1252':
                    return this.InquiryDetail?.countryName_eng
                default:
                    return this.InquiryDetail?.countryName_simp
            }
        },
        productPhoto() {
            if (!this.InquiryDetail.filename) return null
            return this.InquiryDetail.filename + '?x-oss-process=image/resize,w_100/format,webp'
        },
        langId() {
            return localStorage.getItem("currentLangId")
        },
        title() {
            return formatSalesLeadTitleWithCountry(this, 'lbl_EMPBE_SalesLead_fromCountry', {
                buyerCountry: this.countryName,
                compName: this.InquiryDetail.compname,
            });
        }
    },
    methods: {
        unlockQuota(IsLock) {
            this.IsLock = IsLock;
        }
    }
}
</script>
<style lang="scss">
@container (max-width:720px) {
    .enquiry-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        flex: 1 0 0;

        .enquiry-detail {
            display: flex;
            padding: 16px;
            flex-direction: column;
            align-items: flex-start;
            gap: 16px;
            align-self: stretch;
            border-radius: 24px;
            background: var(--Surface, #FFF);
            box-shadow: 0px 2px 15px 0px rgba(183, 183, 183, 0.30);

            .enquiry-header-container {
                display: flex;
                align-items: center;
                gap: 15px;
                align-self: stretch;
            }

            .enquiry-header {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 4px;
                flex: 1 0 0;
                

                .enquiry-title {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    align-self: stretch;

                    .enquiry-title-name {
                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 150%;
                        /* 30px */
                        letter-spacing: -0.22px;
                        min-width: 0;
                        max-width: 100%;
                        white-space: normal;
                        word-break: break-word;
                        overflow-wrap: anywhere;
                    }

                    .enquiry-title-unread {
                        display: flex;
                        padding: 2px 8px;
                        justify-content: center;
                        align-items: center;
                        gap: 4px;
                        border-radius: 125px;
                        background: var(--primary-supplier-backend, #7366FF);
                        color: var(--M3-sys-light-on-error, #FFF);
                        text-align: center;
                        font-family: Roboto;
                        font-size: 13.75px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 20px;
                        /* 145.455% */
                        text-wrap: nowrap;
                        flex-shrink: 0;
                    }
                }

                .enquiry-subtitle {
                    display: flex;
                    justify-content: flex-end;
                    align-items: flex-start;
                    gap: 4px;
                    flex-wrap: wrap;
                    min-width: 0;

                    .enquiry-subtitle-unicode {
                        color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                        font-feature-settings: 'liga' off, 'clig' off;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 150%;
                        /* 21px */
                    }

                    .enquiry-subtitle-date {
                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                        font-feature-settings: 'liga' off, 'clig' off;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 150%;
                        /* 21px */
                    }
                }
            }

            .enquiry-body-container {
                display: flex;
                padding: 8px 16px;
                justify-content: center;
                align-items: flex-start;
                align-self: stretch;
                border-radius: 16px;
                background: #F2F3F5;
                text-wrap: auto;

                .enquiry-body {
                    display: flex;
                    padding: 8px 0px;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 16px;
                    flex: 1 0 0;

                    .enquiry-body-left {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 4px;
                        align-self: stretch;

                        .enquiry-body-left-header {
                            height: 27px;
                            align-self: stretch;
                            color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 150%;
                            /* 27px */
                            letter-spacing: -0.198px;
                        }

                        .enquiry-body-left-requirment-container {
                            display: flex;
                            padding: 20px;
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 16px;
                            align-self: stretch;
                            border-radius: 8px;
                            border: 1px solid #F2F3F5;
                            background: #FFF;

                            .enquiry-body-left-requirment-product {
                                display: flex;
                                align-items: center;
                                gap: 16px;
                                align-self: stretch;

                                .enquiry-body-left-requirment-product-name-container {
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                    align-items: flex-start;
                                    flex: 1 0 0;
                                    align-self: stretch;

                                    .enquiry-body-left-requirment-product-name {
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: center;
                                        flex: 1 0 0;
                                        align-self: stretch;
                                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                        font-size: 18px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: 150%;
                                        /* 27px */
                                        letter-spacing: -0.198px;

                                    }
                                }

                                .enquiry-body-left-requirment-product-img-container {
                                    display: flex;
                                    width: 96px;
                                    height: 96px;
                                    padding: 12.243px 0px 11.757px 0px;
                                    justify-content: center;
                                    align-items: center;
                                    border-radius: 12px;
                                    background-color: #f9f9f9;

                                    img {
                                        width: 96px;
                                        height: 72px;
                                        flex-shrink: 0;
                                        background: lightgray 0px 0px / 100% 100% no-repeat;
                                    }
                                }
                            }

                            .enquiry-body-left-requirment {
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;
                                align-self: stretch;

                                .enquiry-body-left-requirment-title {
                                    color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                                    font-feature-settings: 'liga' off, 'clig' off;
                                    /* Text/Paragraph 3 */
                                    font-size: 12px;
                                    font-style: normal;
                                    font-weight: 400;
                                    line-height: 150%;
                                    /* 18px */
                                }

                                .enquiry-body-left-requirment-detail-container {
                                    display: flex;
                                    align-items: flex-start;
                                    align-content: flex-start;
                                    gap: 2px;
                                    align-self: stretch;
                                    flex-wrap: wrap;

                                    .enquiry-body-left-requirment-detail {
                                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                        font-feature-settings: 'liga' off, 'clig' off;
                                        font-family: Roboto;
                                        font-size: 14px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: 24px;
                                        /* 171.429% */
                                        letter-spacing: 0.15px;
                                    }
                                }
                            }

                        }
                    }

                    .enquiry-body-right {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 4px;
                        align-self: stretch;

                        .enquiry-body-right-title {
                            height: 27px;
                            color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 150%;
                            /* 27px */
                            letter-spacing: -0.198px;
                        }

                        .enquiry-body-right-body {
                            display: flex;
                            padding: 20px;
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 20px;
                            align-self: stretch;
                            border-radius: 8px;
                            border: 1px solid #F2F3F5;
                            background: #FFF;

                            .enquiry-body-right-body-info-container {
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;
                                gap: 8px;
                                align-self: stretch;

                                .enquiry-body-right-body-info {
                                    display: flex;
                                    align-items: flex-start;
                                    align-self: stretch;
                                    flex-direction: column;

                                    .enquiry-body-right-body-info-title {
                                        color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                                        font-feature-settings: 'liga' off, 'clig' off;
                                        width: 160px;
                                        font-size: 12px;
                                        font-style: normal;
                                        font-weight: 400;
                                        line-height: 150%;
                                        /* 18px */
                                    }

                                    .enquiry-body-right-body-info-detail {
                                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                        font-feature-settings: 'liga' off, 'clig' off;
                                        font-family: Roboto;
                                        font-size: 14px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: 24px;
                                        /* 171.429% */
                                        letter-spacing: 0.15px;
                                        min-width: 0;
                                        max-width: 100%;
                                        white-space: normal;
                                        word-break: break-word;
                                        overflow-wrap: anywhere;
                                    }
                                }

                            }

                            .enquiry-body-right-body-text {
                                align-self: stretch;
                                color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                                font-feature-settings: 'liga' off, 'clig' off;

                                /* Text/Paragraph 3 */

                                font-size: 12px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 150%;
                                /* 18px */
                            }
                        }
                    }

                }
            }

        }
    }
}

@container (min-width:721px) {
    .enquiry-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        flex: 1 0 0;
        align-self: stretch;

        .enquiry-detail {
            display: flex;
            padding: 24px;
            flex-direction: column;
            align-items: flex-start;
            gap: 24px;
            align-self: stretch;
            border-radius: 24px;
            background: var(--Surface, #FFF);
            /* Surface shadow */
            box-shadow: 0px 2px 15px 0px rgba(183, 183, 183, 0.30);

            .enquiry-unLock {
                width: 100%;
            }


            .enquiry-header {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                align-self: stretch;
                flex-wrap: wrap;
                gap: 8px;
                min-width: 0;

                .enquiry-title {
                    display: flex;
                    align-items: flex-start;
                    flex-wrap: wrap;
                    gap: 8px;
                    flex: 1 1 0;
                    min-width: 0;
                    max-width: 100%;

                    .enquiry-title-name {
                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                        font-size: 20px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 150%;
                        /* 30px */
                        letter-spacing: -0.22px;
                        min-width: 0;
                        max-width: 100%;
                        white-space: normal;
                        word-break: break-word;
                        overflow-wrap: anywhere;
                    }

                    .enquiry-title-unread {
                        display: flex;
                        padding: 2px 8px;
                        justify-content: center;
                        align-items: center;
                        gap: 4px;
                        border-radius: 125px;
                        background: var(--primary-supplier-backend, #7366FF);
                        color: var(--M3-sys-light-on-error, #FFF);
                        text-align: center;
                        font-family: Roboto;
                        font-size: 13.75px;
                        font-style: normal;
                        font-weight: 500;
                        line-height: 20px;
                        /* 145.455% */
                        flex-shrink: 0;
                    }
                }

                .enquiry-subtitle {
                    display: flex;
                    justify-content: flex-end;
                    align-items: flex-start;
                    gap: 4px;
                    flex-wrap: wrap;
                    flex-shrink: 0;

                    .enquiry-subtitle-unicode {
                        color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                        font-feature-settings: 'liga' off, 'clig' off;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 150%;
                        /* 21px */
                        word-break: break-word;
                        overflow-wrap: anywhere;
                    }

                    .enquiry-subtitle-date {
                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                        font-feature-settings: 'liga' off, 'clig' off;
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 150%;
                        /* 21px */
                    }
                }
            }

            .enquiry-body-container {
                display: flex;
                padding: 8px 16px;
                justify-content: center;
                align-items: flex-start;
                align-self: stretch;
                border-radius: 16px;
                background: #F2F3F5;
                min-width: 0;
                max-width: 100%;

                .enquiry-body {
                    display: flex;
                    padding: 8px 0px;
                    align-items: flex-start;
                    align-content: flex-start;
                    gap: 16px;
                    flex: 1 0 0;
                    flex-wrap: wrap;
                    min-width: 0;
                    max-width: 100%;

                    .enquiry-body-left {
                        display: flex;
                        min-width: 0;
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 4px;
                        flex: 1 1 0;

                        .enquiry-body-left-header {
                            height: 27px;
                            align-self: stretch;
                            color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 150%;
                            /* 27px */
                            letter-spacing: -0.198px;
                        }

                        .enquiry-body-left-requirment-container {
                            display: flex;
                            padding: 20px;
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 16px;
                            align-self: stretch;
                            border-radius: 8px;
                            border: 1px solid #F2F3F5;
                            background: #FFF;

                            .enquiry-body-left-requirment-product {
                                display: flex;
                                align-items: center;
                                gap: 16px;
                                align-self: stretch;

                                .enquiry-body-left-requirment-product-name-container {
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: space-between;
                                    align-items: flex-start;
                                    flex: 1 0 0;
                                    align-self: stretch;

                                    .enquiry-body-left-requirment-product-name {
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: center;
                                        flex: 1 0 0;
                                        align-self: stretch;
                                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                        font-size: 18px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: 150%;
                                        /* 27px */
                                        letter-spacing: -0.198px;

                                    }
                                }


                                .enquiry-body-left-requirment-product-img-container {
                                    display: flex;
                                    width: 96px;
                                    height: 96px;
                                    padding: 12.243px 0px 11.757px 0px;
                                    justify-content: center;
                                    align-items: center;
                                    border-radius: 12px;
                                    background-color: #f9f9f9;

                                    img {
                                        width: 96px;
                                        height: 72px;
                                        flex-shrink: 0;
                                        background: lightgray 0px 0px / 100% 100% no-repeat;
                                    }
                                }
                            }

                            .enquiry-body-left-requirment {
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;
                                align-self: stretch;

                                .enquiry-body-left-requirment-title {
                                    color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                                    font-feature-settings: 'liga' off, 'clig' off;
                                    /* Text/Paragraph 3 */
                                    font-size: 12px;
                                    font-style: normal;
                                    font-weight: 400;
                                    line-height: 150%;
                                    /* 18px */
                                }

                                .enquiry-body-left-requirment-detail-container {
                                    display: flex;
                                    align-items: flex-start;
                                    align-content: flex-start;
                                    gap: 2px;
                                    align-self: stretch;
                                    flex-wrap: wrap;

                                    .enquiry-body-left-requirment-detail {
                                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                        font-feature-settings: 'liga' off, 'clig' off;
                                        font-family: Roboto;
                                        font-size: 14px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: 24px;
                                        /* 171.429% */
                                        letter-spacing: 0.15px;
                                    }
                                }
                            }

                        }
                    }

                    .enquiry-body-right {
                        display: flex;
                        min-width: 0;
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 4px;
                        flex: 1 1 280px;
                        max-width: 100%;

                        .enquiry-body-right-title {
                            width: 100%;
                            height: 27px;
                            color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                            font-size: 18px;
                            font-style: normal;
                            font-weight: 700;
                            line-height: 150%;
                            /* 27px */
                            letter-spacing: -0.198px;
                        }

                        .enquiry-body-right-body {
                            display: flex;
                            padding: 20px;
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 20px;
                            align-self: stretch;
                            border-radius: 8px;
                            border: 1px solid #F2F3F5;
                            background: #FFF;

                            .enquiry-body-right-body-info-container {
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;
                                gap: 8px;
                                align-self: stretch;

                                .enquiry-body-right-body-info {
                                    display: flex;
                                    align-items: flex-start;
                                    align-self: stretch;
                                    gap: 8px;
                                    min-width: 0;
                                    max-width: 100%;

                                    .enquiry-body-right-body-info-title {
                                        color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                                        font-feature-settings: 'liga' off, 'clig' off;
                                        flex: 0 0 160px;
                                        width: 160px;
                                        font-size: 12px;
                                        font-style: normal;
                                        font-weight: 400;
                                        line-height: 150%;
                                        /* 18px */
                                    }

                                    .enquiry-body-right-body-info-detail {
                                        color: var(--on-surface-80, rgba(0, 0, 0, 0.80));
                                        font-feature-settings: 'liga' off, 'clig' off;
                                        font-family: Roboto;
                                        font-size: 14px;
                                        font-style: normal;
                                        font-weight: 500;
                                        line-height: 24px;
                                        /* 171.429% */
                                        letter-spacing: 0.15px;
                                        flex: 1 1 0;
                                        min-width: 0;
                                        max-width: 100%;
                                        white-space: normal;
                                        word-break: break-word;
                                        overflow-wrap: anywhere;
                                    }
                                }

                            }

                            .enquiry-body-right-body-text {
                                align-self: stretch;
                                color: var(--on-surface-40, rgba(0, 0, 0, 0.40));
                                font-feature-settings: 'liga' off, 'clig' off;

                                /* Text/Paragraph 3 */

                                font-size: 12px;
                                font-style: normal;
                                font-weight: 400;
                                line-height: 150%;
                                /* 18px */
                            }
                        }
                    }

                }
            }

        }
    }
}

.enquiry-container {
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;

    .enquiry-detail {
        min-width: 0;
        max-width: 100%;
        box-sizing: border-box;
    }

    .enquiry-title-name,
    .enquiry-body-right-body-info-detail,
    .enquiry-body-left-requirment-product-name,
    .enquiry-body-left-requirment-detail {
        white-space: normal;
        word-break: break-word;
        overflow-wrap: anywhere;
        max-width: 100%;
        min-width: 0;
    }

    .enquiry-title {
        flex-wrap: wrap;
        min-width: 0;
        max-width: 100%;
    }

    .enquiry-body-right-body-info {
        min-width: 0;
        max-width: 100%;
    }

    .enquiry-body-left-requirment-product-name-container {
        min-width: 0;
        max-width: 100%;
    }
}

.enquiry-remarks {
    align-self: stretch;
    width: 100%;
    box-sizing: border-box;
}
</style>